/**
 * @typedef {object} EstadoDocumentoProps
 * @property {any} [color]
 * @property {any} [backgroundColor]
 * @property {any} [text]
 * @property {any} [id]
 * @property {any} [className]
 * @property {any} [disabled]
 * @property {any} [fontSize]
 * @property {any} [padding]
 * @property {any} [width]
 * @property {any} [motivo]
 */

/**
 * @param {EstadoDocumentoProps} props
 */

const EstadoDocumento = ({
  color,
  backgroundColor,
  text,
  id = "",
  className,
  disabled,
  fontSize,
  padding = "5px 10px",
  width,
}: $TSMigrationFixMe) => {
  return (
    <>
      <div
        className={`factura-tooltip-${id} ${className} estadoRevisionActual font-medium`}
        style={{
          fontWeight: 500,
          borderRadius: "6px",
          display: "flex",
          justifyContent: "center",
          whiteSpace: "nowrap",
          padding,
          color,
          backgroundColor,
          opacity: disabled ? 0.5 : 1,
          fontSize,
          width,
        }}
      >
        {text}
      </div>
    </>
  )
}

export default EstadoDocumento
